// web/src/stores/authStore.ts — auth state + token persistence.
//
// Tokens are persisted to localStorage so a page reload keeps the session.
// The store is consumed by both React components (via the hook) and the
// apiClient (via getState()) so a refresh updates every in-flight request.
import { create } from "zustand";
import { persist } from "zustand/middleware";
export const useAuthStore = create()(persist((set, get) => ({
    accessToken: null,
    refreshToken: null,
    email: null,
    avatarSeed: null,
    isAuthenticated: () => !!get().accessToken,
    setTokens: (access, refresh, email) => {
        // Purge any stale per-user data from localStorage on every login/signup.
        localStorage.removeItem("matchrail-chat");
        localStorage.removeItem("matchrail-chat-threads");
        localStorage.removeItem("matchrail-conversations");
        localStorage.removeItem("matchrail-agents");
        set({ accessToken: access, refreshToken: refresh, email, avatarSeed: null });
    },
    setAvatarSeed: (seed) => set({ avatarSeed: seed }),
    refresh: async () => {
        const rt = get().refreshToken;
        if (!rt)
            return false;
        try {
            const res = await fetch("/api/auth/refresh", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ refresh_token: rt }),
            });
            if (!res.ok)
                return false;
            const data = (await res.json());
            set({ accessToken: data.access_token, refreshToken: data.refresh_token });
            return true;
        }
        catch {
            return false;
        }
    },
    logout: () => {
        set({ accessToken: null, refreshToken: null, email: null, avatarSeed: null });
        localStorage.removeItem("matchrail-chat");
        localStorage.removeItem("matchrail-chat-threads");
        // Hard navigation forces browser to re-fetch index.html and pick up
        // any new JS bundles deployed since this page was loaded.
        window.location.href = "/login";
    },
}), { name: "matchrail-auth" }));
